import React from 'react';
import { useSelector } from 'react-redux';
import { CoreLink } from '..';

import { DEFAULT_LANGUAGE } from '../../config/constants';

import './style.scss';

const Breadcrumbs = ({ includeCurrent, hideHome, customCrumbs }) => {

  const breadcrumbs = customCrumbs || useSelector((state) => state.getIn(['entity', 'breadcrumbs']));
  const { currentTitle, currentUrl, fullTitle } = useSelector((state) => {
    const entityId = state.getIn(['entity', 'entityId']);
    const entityType = state.getIn(['entity', 'entityType']);
    const entity = state.getIn([entityType, entityId]);
    if (!entity) {
      return { currentTitle: null, currentUrl: null };
    }
    const title = entity.getIn(['title', 0, 'value']);
    const url = entity.getIn(['paths', DEFAULT_LANGUAGE]);
    const truncatedTitle = title.length > 20 ? `${title.substring(0, 20)}...` : title;

    return { currentTitle: truncatedTitle, currentUrl: url, fullTitle: title };
  });

  // Render the desktop breadcrumbs
  let breadcrumbItems = breadcrumbs.map((item, index) => {
    const url = item.get('url');
    let title = item.get('title');

    if (hideHome && index === 0) {
      return;
    }

    if (hideHome && index === 1) {
      title = 'Home';
    }

    title = title.length > 20 ? `${title.substring(0, 20)}...` : title;
    return (
      <li key={url} className="Breadcrumbs__wrapper__item" property="itemListElement" typeof="ListItem">
        <CoreLink
          property="item"
          typeof="WebPage"
          to={url}
        >
          {title}
          {title.length > 20 && (
            <div className="tooltip">
              {item.get('title')}
            </div>
          )}
        </CoreLink>
        <meta property="position" content={index} />
      </li>
    );
  });

  // Render our mobile breadcrumb
  const mobileBreadcrumb = () => {
    const secondToLastBreadcrumb = breadcrumbs.get(breadcrumbs.size - 1, null);

    if (secondToLastBreadcrumb) {
      let title = secondToLastBreadcrumb ? secondToLastBreadcrumb.get('title') : null;
      title = title.length > 20 ? `${title.substring(0, 20)}...` : title;

      return (
        <div className="Breadcrumbs__mobile_box">
          <div className="Breadcrumbs__mobile_box__left">
            <i className="icon icon-arrow-left" />
          </div>
          <div className="Breadcrumbs__mobile_box__right">
            <div>
              <CoreLink property="item" typeof="WebPage" to={secondToLastBreadcrumb.get('url')}>
                Naar {title}
              </CoreLink>
            </div>
          </div>
        </div>
      );
    }
  };

  // Check if we need to include the current page in the breadcrumbs
  if (includeCurrent && currentTitle && currentUrl) {
    const index = breadcrumbItems.size + 1;
    breadcrumbItems = breadcrumbItems.push(
      <li key={currentUrl} className="Breadcrumbs__wrapper__item" property="itemListElement" typeof="ListItem">
        <CoreLink
          property="item"
          typeof="WebPage"
          to={currentUrl}
        >
          {currentTitle}
          {fullTitle.length > 20 && (
            <div className="tooltip">
              {fullTitle}
            </div>
          )}
        </CoreLink>
        <meta property="position" content={index} />
      </li>,
    );
  }

  return (
    <div className="Breadcrumbs">
      {/* Mobile breadcrumb */}
      {mobileBreadcrumb()}

      {/* Desktop breadcrumbs */}
      <ol className="Breadcrumbs__wrapper" vocab="https://schema.org/" typeof="BreadcrumbList">
        {breadcrumbItems}
      </ol>
    </div>
  );
};

export default Breadcrumbs;
